var map = {
	"./PGA_LoginBackground.png": 2206,
	"./bannerLogo_americas.png": 6834,
	"./bannerLogo_canada.png": 1906,
	"./bannerLogo_champions.png": 5828,
	"./bannerLogo_forme.png": 3736,
	"./bannerLogo_kornferry.png": 8999,
	"./bannerLogo_latinoamerica.png": 1193,
	"./bannerLogo_mackenzie.png": 7334,
	"./bannerLogo_mental_health.png": 9452,
	"./bannerLogo_pga.png": 2253,
	"./banner_americas.png": 6103,
	"./banner_canada.png": 2706,
	"./banner_champions.png": 5476,
	"./banner_commitment.png": 4791,
	"./banner_dashboard.png": 8020,
	"./banner_kornferry.png": 8060,
	"./banner_latinoamerica.png": 4479,
	"./banner_pga.png": 7499,
	"./circle.png": 5490,
	"./logo_americas.png": 2046,
	"./logo_canada.png": 7183,
	"./logo_champions.png": 532,
	"./logo_forme.png": 1760,
	"./logo_kornferry.png": 9537,
	"./logo_latinoamerica.png": 1350,
	"./logo_mackenzie.png": 2250,
	"./logo_pgabandw.png": 7206,
	"./logo_pgacolor.png": 1517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3778;